import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "history-hanging-last-mile",
  class: "w-full h-full bg-gray-100 p-2"
}
const _hoisted_2 = { class: "flex flex-col gap-y-2 mt-2 mb-2 h-full" }
const _hoisted_3 = {
  key: 0,
  class: "overflow-auto border border-gray-lp-1400 rounded-2xl",
  style: {"max-height":"calc(calc(100vh / var(--viewport-scale)) - 330px)"}
}
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "bg-gray-lp-700 text-sm text-gray-lp-300 font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-1/20" }, [
  /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " No. ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-2/20" }, [
  /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " No Manifest ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-2/20" }, [
  /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " No. STT ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-2/20" }, [
  /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " Hanging ")
], -1)
const _hoisted_10 = { class: "py-2.5 w-3/20" }
const _hoisted_11 = { class: "px-3 flex justify-start" }
const _hoisted_12 = { class: "py-2.5 w-3/20" }
const _hoisted_13 = { class: "px-3 flex justify-start" }
const _hoisted_14 = { class: "py-2.5 w-3/20" }
const _hoisted_15 = { class: "px-3 flex justify-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_19 = { class: "text-left px-3 py-3 font-bold" }
const _hoisted_20 = { class: "text-left px-3 py-3" }
const _hoisted_21 = { class: "flex flex-col items-start gap-1" }
const _hoisted_22 = { class: "font-bold" }
const _hoisted_23 = {
  key: 0,
  class: "font-normal text-xs px-2 rounded-lg bg-gray-lp-1000"
}
const _hoisted_24 = { class: "text-left px-3 py-3" }
const _hoisted_25 = { class: "text-left px-3 py-3" }
const _hoisted_26 = { class: "flex flex-col items-start gap-1" }
const _hoisted_27 = {
  key: 0,
  class: "text-gray-lp-300 font-normal text-10px"
}
const _hoisted_28 = { class: "text-left px-3 py-3 font-normal text-sm" }
const _hoisted_29 = { class: "text-center px-3 py-3" }
const _hoisted_30 = { class: "flex flex-col items-center" }
const _hoisted_31 = { class: "font-normal text-xs px-2 rounded-lg bg-gray-lp-1000 mb-1" }
const _hoisted_32 = { class: "font-bold text-10px" }
const _hoisted_33 = { class: "font-normal text-10px" }
const _hoisted_34 = {
  key: 0,
  class: "px-3 bg-white rounded-2xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterHistory = _resolveComponent("FilterHistory")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["p-3 bg-white flex flex-col gap-y-2 rounded-2xl", `${ !_ctx.dataListRiwayatHangingLasmile.length && !_ctx.isLoading ? 'h-full' : '' }`]
      }, [
        _createVNode(_component_FilterHistory, { onFilter: _ctx.filterHistoryHangingLastMile }, null, 8, ["onFilter"]),
        (_ctx.dataListRiwayatHangingLasmile.length || _ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("table", _hoisted_4, [
                _createVNode("thead", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _createVNode("th", _hoisted_10, [
                    _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('dashboard.hanging.statusPackageExistence')), 1)
                  ]),
                  _createVNode("th", _hoisted_12, [
                    _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('dashboard.hanging.packageLocation')), 1)
                  ]),
                  _createVNode("th", _hoisted_14, [
                    _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('dashboard.hanging.notes')), 1)
                  ])
                ]),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock("tbody", _hoisted_16, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (index) => {
                        return _createVNode("tr", {
                          key: index,
                          class: "cursor-wait border-t border-gray-lp-1400"
                        }, [
                          (_openBlock(), _createBlock(_Fragment, null, _renderList(7, (indexColumn) => {
                            return _createVNode("td", {
                              key: indexColumn,
                              class: "px-3 py-3"
                            }, [
                              _createVNode(_component_Skeleton, { height: "1.3rem" })
                            ])
                          }), 64))
                        ])
                      }), 64))
                    ]))
                  : (_openBlock(), _createBlock("tbody", _hoisted_17, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataListRiwayatHangingLasmile, (item, index) => {
                        return (_openBlock(), _createBlock("tr", {
                          key: `history-incoming-${index}`,
                          class: "border-t border-gray-lp-1400 text-sm text-gray-lp-300"
                        }, [
                          _createVNode("td", _hoisted_18, _toDisplayString(index + 1 + _ctx.pagination.limit * (_ctx.pagination.page - 1)), 1),
                          _createVNode("td", _hoisted_19, _toDisplayString(item.manifestNo || "-"), 1),
                          _createVNode("td", _hoisted_20, [
                            _createVNode("div", _hoisted_21, [
                              _createVNode("span", _hoisted_22, _toDisplayString(item.sttNo), 1),
                              (item.aggregator)
                                ? (_openBlock(), _createBlock("span", _hoisted_23, "Aggregator"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("td", _hoisted_24, [
                            _createVNode("span", {
                              class: ["font-normal text-sm py-0.5 px-2 rounded-md", `${_ctx.mapHangingDays(item).color}`]
                            }, _toDisplayString(_ctx.mapHangingDays(item).label), 3)
                          ]),
                          _createVNode("td", _hoisted_25, [
                            _createVNode("div", _hoisted_26, [
                              _createVNode("span", {
                                class: ["font-normal text-sm py-0.5 px-2 rounded-2xl", `${_ctx.mapTicketStatus(item).color}`]
                              }, _toDisplayString(_ctx.mapTicketStatus(item).label), 3),
                              (item.existenceStatus !== 'belum_ditemukan' && item.existenceStatus)
                                ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(item.existenceUsername) + _toDisplayString(item.existenceFindAt ? ' - ' + _ctx.extractDateTime(item.existenceFindAt) : ''), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("td", _hoisted_28, _toDisplayString(item.existenceLocation ? item.existenceLocation : '-'), 1),
                          _createVNode("td", _hoisted_29, [
                            _createVNode("div", _hoisted_30, [
                              _createVNode("span", _hoisted_31, _toDisplayString(item.status), 1),
                              _createVNode("span", _hoisted_32, _toDisplayString(item.username), 1),
                              _createVNode("span", _hoisted_33, _toDisplayString(item.createdAt ? _ctx.$moment(item.createdAt).format('DD MMMM YYYY, HH:mm') : '-'), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
              ])
            ]))
          : (_ctx.errorCause)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 1,
                class: "h-full",
                errorType: _ctx.errorCause
              }, null, 8, ["errorType"]))
            : (_openBlock(), _createBlock(_component_EmptyState, {
                key: 2,
                class: "h-full",
                icon: "noData_empty",
                customHeaderMessage: _ctx.$t('dashboard.hanging.emptyHeader'),
                customMessage: _ctx.$t('dashboard.hanging.emptyMessage')
              }, null, 8, ["customHeaderMessage", "customMessage"]))
      ], 2),
      (_ctx.dataListRiwayatHangingLasmile.length && !_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_34, [
            _createVNode(_component_PaginationV3, {
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
              onSetPage: _ctx.toPageV3,
              renderedData: _ctx.dataListRiwayatHangingLasmile.length,
              paginationWidth: "w-full",
              paginationPaddingVertical: "py-1"
            }, null, 8, ["pagination", "onSetPage", "renderedData"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}